// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Kn-z","badgeLink":"Ln-z","category":"Mn-z"};